<template >
  <!-- About Start -->
    <section id="about" class="about" >
      <div class="about-decor d-none d-lg-block">
        <!-- <div class="about-circle1"><img :src='"../assets/images/team1.png"' alt="team1"></div> -->
        <div class="about-circle2"><img class="circle-3" :src='"../assets/images/circle-3.png"' alt="banner1"></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="about-contain pl-3">
              <div>
                <h2 class="text-uppercase mb-4 f-300">{{ $t('about.title') }} <span class="f-600">Weserve</span> <span class="green f-500">Go</span></h2>
                <p class="mb-5">{{ $t('about.subtitle') }}</p>
                <div class="row sm-mb">
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="list-hover">
                        <div class="about-icon">
                          <div class="icon-hover mb-2">
                            <img style="max-width: 55px" :src='"../assets/images/rental.png"' alt="Car Rental">
                          </div>
                        </div>
                        <div class="about-text">
                          <p>{{ $t('about.button1') }}</p>
                        </div>
                      </li>
                      <li class="list-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img style="max-width: 47px" :src='"../assets/images/driving.png"' alt="Driver">
                          </div>
                        </div>
                        <div class="about-text">
                          <p>{{ $t('about.button2') }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="list-hover">
                        <div class="about-icon">
                          <div class="icon-hover mb-2">
                            <img style="max-width: 62px" :src='"../assets/images/driver.png"' alt="Car & Driver">
                          </div>
                        </div>
                        <div class="about-text">
                          <p>{{ $t('about.button3') }}</p>
                        </div>
                      </li>
                      <li class="list-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img style="max-width: 50px" :src='"../assets/images/customer.png"' alt="Sharing Car">
                          </div>
                        </div>
                        <div class="about-text">
                          <p>{{ $t('about.button4') }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-medium-none">
            <div class="about-right">
              <Tile maxWidth="50%" image='about-mobile.jpg'/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About End -->

</template>
<script>
export default {
  name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue